<template>
  <div class="msg-system-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">发布系统消息</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加/编辑的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="msg"
            ref="msgValidate"
            :rules="msgValidate"
            action="javascript:void(0)">
        <FormItem label="标题"
                  label-position="top"
                  prop="title">
          <Input v-model="msg.title"
                 placeholder="标题">></Input>
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="msg.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="628"
                        :autoCropHeight="268"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:628*268,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="消息类型"
                  prop="sys_msg_cate_id">
          <RadioGroup v-model="msg.sys_msg_cate_id">
            <Radio label="1">系统消息</Radio>
            <Radio label="2">站内通告</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="内容"
                  prop="content">
          <!--                    <editor-bar v-model="msg.content" :isClear="isClear" ref="editContent" @change="change"></editor-bar>-->
          <UEditor v-model="msg.content"
                   ref="editContent"></UEditor>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="submitMsg('msgValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- <Modal v-model="showModalStatus" :title="title" @on-ok="submitMsg('msgValidate')" :loading="loading" :mask-closable="false">

        </Modal> -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb"
import UEditor from '../common/ueditor';

export default {
  name: 'msg-system-list',
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error('请上传封面图'));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.msg.content == '') {
        callback(new Error('内容必须填写'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: false,
      showModalStatus: false,  // 编辑添加弹窗
      isClear: false,
      formItem: [],
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 60,
          fixed: 'left'
        },
        {
          title: '封面图',
          key: 'thumb',
          width: 80,
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            let thumbImg = params.row.thumb.indexOf('https') > -1 ? zUrl + params.row.thumb : params.row.thumb;
            return h('div', [
              h('Avatar', {
                props: {
                  src: thumbImg
                },
              }, '')
            ]);
          }
        },
        {
          title: '标题',
          key: 'title',
        },
        {
          title: '内容',
          key: 'content',
          tooltip: true
        },
        {
          title: '类型',
          key: 'content',
          render: (h, params) => {
            var s_name = new Array();
            s_name[1] = "系统消息";
            s_name[2] = "站内通告";
            return h('div', [
              h('span', {}, s_name[params.row.sys_msg_cate_id])
            ]);
          }
        },
        {
          title: '发布时间',
          key: 'created_at',
        },
        // {
        //     title: '状态',
        //     // key: 'status',
        //     render: (h, params) => {
        //         var s_name = new Array();
        //         s_name[1] = "正常";
        //         s_name[0] = "禁用";
        //         return h('div', [
        //             h('span', {}, s_name[params.row.status])
        //         ]);
        //     }
        // },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          render: (h, params) => {
            return h('div', [
              // h('Button', {
              //         props: {
              //             type: 'info',
              //             size: 'small'
              //         },
              //         style: {
              //             marginRight: '5px'
              //         },
              //         on: {
              //             click: () => {
              //                 this.showDetail(params.row.id)
              //             }
              //         }
              //     }, '查看'),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      thumblist: [],
      msg: {
        id: null,
        sys_msg_cate_id: '1',  // 1系统消息，2站内消息
        title: '',
        content: '',
        thumb: null,
      },
      msgValidate: {
        title: [
          { required: true, message: '消息名称必须填写', trigger: 'blur' }
        ],
        content: [
          { required: true, validator: validateContent, trigger: "change" }
        ],
        thumb: [
          { required: true, validator: validateThumb, trigger: 'change' }
        ],
      }
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    UEditor,
  },
  methods: {
    // 获取消息列表
    getTableList: function () {
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.sysmsg.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    submitMsg (name) {
      var that = this
      that.msg.content = this.$refs['editContent'].message;
      that.$refs[name].validate(valid => {
        console.log(valid)
        if (valid) {
          if (that.$refs["uploadthumb"].uploadList.length > 0) {
            that.msg.thumb = that.$refs["uploadthumb"].uploadList[0].url;
          } else {
            that.msg.thumb = null;
          }

          if (that.msg.id && that.msg.id != undefined && that.msg.id != '') {
            that.$api.sysmsg.edit(that.msg).then(res => {
              that.loading = false;
              if (res.code == 200) {
                that.showModalStatus = false
                that.getTableList()
              }
            });
          } else {
            that.$api.sysmsg.create(that.msg).then(res => {
              that.loading = false;
              if (res.code == 200) {
                that.showModalStatus = false
                that.getTableList()
              }
            });
          }

        }
      })

    },
    remove (id) {
      var that = this
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.sysmsg.remove({ id: id }).then(res => {
            if (res.code == 200) {
              that.$Message.success(res.msg);
              that.getTableList()
            }
          });
        }
      });
    },
    // 查看消息详情
    showEditInfo: function (id) {
      var that = this;
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs['editContent'].message = '';
      this.thumblist = new Array();
      var msg = {
        id: null,
        sys_msg_cate_id: '1',  // 1系统消息，2站内消息
        title: '',
        content: '',
        thumb: null,
      }
      this.msg = msg
      that.$api.sysmsg.detail({ id: id }).then(res => {
        console.log(res)
        if (res.code == 200) {
          that.msg = res.result
          console.log(that.msg.content)
          // this.$refs["editContent"].editor.txt.html(res.result.content);
          this.$refs['editContent'].message = res.result.content;
          that.msg.sys_msg_cate_id = res.result.sys_msg_cate_id.toString()
          if (that.msg.thumb != null && that.msg.thumb != "") {
            that.thumblist.push({
              name: that.msg.thumb,
              url: that.msg.thumb,
              status: "finished"
            });
          }
          that.showMsgModel()
        }
      })
    },
    showModel () {
      var msg = {
        id: null,
        sys_msg_cate_id: '1',  // 1系统消息，2站内消息
        title: '',
        content: '',
        thumb: null,
      }
      this.thumblist = []
      this.msg = msg
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs['editContent'].message = '';
      this.showMsgModel()
    },
    showMsgModel () {
      this.$refs["msgValidate"].resetFields();
      this.showModalStatus = true
    },
    change () {

    }
  },
}
</script>
